/******
 * This file was generated by a Rake task.
 * Do not modify this file manually.
 * Add changes to the `ExecutiveCommandSection.ts` file.
 ******/
import dayjs, { Dayjs } from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
dayjs.extend(utc);
dayjs.extend(timezone);

import { ExecutiveCommandSection } from "./ExecutiveCommandSection";

import { ExecutiveCommandView } from "./ExecutiveCommandView";
import { Project } from "./Project";

export abstract class ExecutiveCommandSectionModel {
    id: number;
    commandCenterViewId: number;
    createdAt: Dayjs;
    executiveCommandViewId: number;
    position: number;
    projectId: number;
    updatedAt: Dayjs;
    executiveCommandView: ExecutiveCommandView | null | undefined;
    project: Project | null | undefined;
    _destroy: boolean | undefined;

    constructor(
        id: number,
        commandCenterViewId: number,
        createdAt: Dayjs,
        executiveCommandViewId: number,
        position: number,
        projectId: number,
        updatedAt: Dayjs,
        executiveCommandView: ExecutiveCommandView | null | undefined,
        project: Project | null | undefined
    ) {
        this.id = id;
        this.commandCenterViewId = commandCenterViewId;
        this.createdAt = createdAt;
        this.executiveCommandViewId = executiveCommandViewId;
        this.position = position;
        this.projectId = projectId;
        this.updatedAt = updatedAt;
        this.executiveCommandView = executiveCommandView;
        this.project = project;
    }

    static fromApiObject(json: any, timezone: string): ExecutiveCommandSection {
        const newObject = new ExecutiveCommandSection(
            json["id"],
            json["command_center_view_id"],
            dayjs(json["created_at"]).tz(timezone),
            json["executive_command_view_id"],
            json["position"],
            json["project_id"],
            dayjs(json["updated_at"]).tz(timezone),
            json["executive_command_view"] == null
                ? json["executive_command_view"]
                : ExecutiveCommandView.fromApiObject(json["executive_command_view"], timezone),
            json["project"] == null ? json["project"] : Project.fromApiObject(json["project"], timezone)
        );

        return newObject;
    }

    toApiObject(): any {
        return {
            id: this.id,
            command_center_view_id: this.commandCenterViewId,
            created_at: this.createdAt,
            executive_command_view_id: this.executiveCommandViewId,
            position: this.position,
            project_id: this.projectId,
            updated_at: this.updatedAt,
            _destroy: this._destroy,
        };
    }

    // NOTE: This could potentially cause infinite loops if the object graph is
    // circular.
    inAlternateTimezone(timezone: string): ExecutiveCommandSection {
        const clone = Object.create(this) as ExecutiveCommandSection;

        for (const key of Object.keys(this)) {
            if (this[key] instanceof dayjs) {
                // @ts-expect-error: Typescript thinks that this is not a dayjs object even though it is checked on the line before
                clone[key] = this[key].tz(timezone);
            } else if (Array.isArray(this[key])) {
                clone[key] = this[key].map((item) =>
                    item.inAlternateTimezone ? item.inAlternateTimezone(timezone) : item
                );
            } else if (this[key] && this[key].inAlternateTimezone) {
                clone[key] = this[key].inAlternateTimezone(timezone);
            }
        }

        return clone;
    }
}
